import React,{ Component } from 'react'
import { NavLink, Route,Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import {signOut } from '../actions'

import Menu from '../components/user_menu'

import Perfil from '../components/user_menu'
import Direcciones from '../containers/lista_direcciones'
import Pedidos from '../containers/lista_direcciones'
import Direccion from '../containers/direccion'



class PanelUsuario extends Component{

	constructor(props) {
    super(props);
    this.state = {
      imgPrefix:""
    }

  }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
  }

  componentDidUpdate(prevProps, prevState){

  }

    render() {
      return (
        <section className="container-fluid mb-5 sombraHead mt-3 clearfix" >
          <div className="col-md-4 mb-3">
             <Menu salirAct={this.props.signOut}/>
          </div>
          <div className="col-md-4 mb-3">

          </div>
        </section>
		  )
	  }
}

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => {
      dispatch(signOut())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PanelUsuario)




// WEBPACK FOOTER //
// ./src/containers/panel_usuario.js